module.exports = __webpack_public_path__ + "img/elephant_m.c6a8379e.png";